import * as React from "react";
import {
    Datagrid,
    List,
    Show,
    Create,
    ImageField,
    ImageInput,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    TextInput,
    ShowButton,
    EditButton,
    DeleteButton,
    RichTextField,
    FileInput,
    FileField,
    Edit,
    ReferenceField,
    ReferenceInput,
    AutocompleteInput,
    BooleanField,
    BooleanInput,
    UrlField,
} from "react-admin";

export const pubList = (props) => (
    <List
        {...props}
    >
        <Datagrid>
            <TextField source="label" label="Label" />
            <ImageField source="image.src" label="Image"></ImageField>
            <BooleanField source="enabled" />
            <DeleteButton label="" redirect={false} />
            <EditButton label="" />
            <ShowButton />

        </Datagrid>
    </List>
);

// const ConditionalEmailField = ({}) =>
//   record && record.hasEmail ? (
//     <EmailField source="email" record={record} {...rest} />
//   ) : null;
export const pubShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="label" label="Label" />
            <ImageField source="image.src" label="Image"></ImageField>
            <UrlField source="url" label="URL" />
            <BooleanField source="enabled" />
        </SimpleShowLayout>
    </Show>
);

export const pubCreate = (props) => (

    <Create {...props}>
        <SimpleForm>
            <TextInput source="label" label="Label" />
            <ImageInput source="image" label="Image (320x50)" >
                <ImageField source="src" title="Image" />
            </ImageInput>
            <TextInput source="url" label="URL" />
            <BooleanInput defaultValue={true} source="enabled" label="Enabled" />
        </SimpleForm>
    </Create>
);

export const pubEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
        <TextInput source="label" label="Label" />
            <ImageInput source="image" label="Image (320x50)" >
                <ImageField source="src" title="Image" />
            </ImageInput>
            <TextInput source="url" label="URL" />
            <BooleanInput source="enabled" label="Enabled" />
        </SimpleForm>
    </Edit>
);
